import React from "react";
import { Colors } from "../palettes/colorPalette";
import { backgroundTexture } from "../uiConstants";
import { Debug } from "../../../shared/debug";
import { getWebServicesList } from "../networking/webServicesList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCopy } from "@fortawesome/free-solid-svg-icons";
import { GameClient } from "../gameClient";
import { UIButtonSmall } from "../styles/ButtonStyle";

declare var gameClient: GameClient;

export const HostDisconnectedBanner = () => {
	const [copied, setCopied] = React.useState(false);
	const failed = gameClient.hostReconnect?.failed ?? false;
	//A browser host invited by link, and shows the link below instead. A joining player has no
	//invite to offer at all.
	const isSteamHost = !gameClient.isSpawnGame && !gameClient.signallingServerLobbyCode;

	const copyLink = async () => {
		try {
			const lobbyCode = gameClient.signallingServerLobbyCode!;
			const Services = await getWebServicesList();
			let connectText = Services.JoinUrlTemplate.replace('[LOBBY_ID]', lobbyCode);
			if (Debug.UseLocalJoinUrl) {
				connectText = `${window.location.href.split('?')[0]}?lobby=${lobbyCode}`;
			}
			await navigator.clipboard.writeText(connectText);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch (e) {
			console.log('Copying to clipboard was not successful');
		}
	};

	return (
		<div style={{
			position: 'absolute',
			top: '5%',
			left: '50%',
			transform: 'translate(-50%, 0)',
			zIndex: 20,
			background: `url(${backgroundTexture})`,
			backgroundColor: Colors.UIBackground,
			padding: '0.75vw 1.5vw',
			filter: `drop-shadow(2px 4px 2px ${Colors.UITextAndBorders})`,
			fontSize: '1.5vw',
			color: Colors.UITextAndBorders,
			textAlign: 'center',
		}}>
			<div>{failed ? 'Unable to Reconnect' : 'Opponent disconnected — waiting for reconnect…'}</div>
			{isSteamHost && (
				<div style={{ marginTop: '0.5vw', fontSize: '0.8em' }}>
					If they closed the game, they can rejoin from their Steam friends list
				</div>
			)}
			{gameClient.signallingServerLobbyCode && (
				<div style={{ marginTop: '0.5vw', cursor: 'pointer' }} onClick={copyLink}>
					<span>Join Id: {gameClient.signallingServerLobbyCode} </span>
					<FontAwesomeIcon icon={copied ? faCheck : faCopy} />
				</div>
			)}
			{failed && (
				<UIButtonSmall
					style={{ marginTop: '0.5vw', fontSize: '0.66em' }}
					onClick={() => gameClient.hostReconnect?.retry()}
				>
					Try Again
				</UIButtonSmall>
			)}
		</div>
	);
};
